import React, { useEffect, createElement } from 'react';
import { Hero } from './Hero';
import { PainPoints } from './PainPoints';
import { Benefits } from './Benefits';
import { LeadForm } from './LeadForm';
import { Trust } from './Trust';
import { Footer } from './Footer';
const PIXEL_ID = '2177547493069894';
function initMetaPixel() {
  if (typeof window === 'undefined') return;
  if ((window as any).fbq) return;
  // Initialize fbq queue
  const f = window as any;
  const n = function (...args: any[]) {
    if (n.callMethod) {
      n.callMethod.apply(n, args);
    } else {
      n.queue.push(args);
    }
  } as any;
  n.push = n;
  n.loaded = true;
  n.version = '2.0';
  n.queue = [] as any[];
  f.fbq = n;
  if (!f._fbq) f._fbq = n;
  // Queue init and PageView before script loads
  f.fbq('init', PIXEL_ID);
  f.fbq('track', 'PageView');
  // Load the Facebook Pixel script
  const script = document.createElement('script');
  script.async = true;
  script.src = 'https://connect.facebook.net/en_US/fbevents.js';
  document.head.appendChild(script);
  // Also add noscript fallback image
  const noscript = document.createElement('img');
  noscript.height = 1;
  noscript.width = 1;
  noscript.style.display = 'none';
  noscript.src = `https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`;
  document.body.appendChild(noscript);
}
export function trackMetaEvent(eventName: string, data?: Record<string, any>) {
  if (typeof window !== 'undefined' && (window as any).fbq) {
    ;
    (window as any).fbq('track', eventName, data);
  }
}
export function LandingPage() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="min-h-screen bg-white font-sans" data-id="element-49">
      <Hero data-id="element-50" />
      <PainPoints data-id="element-51" />
      <Benefits data-id="element-52" />
      <LeadForm data-id="element-53" />
      <Trust data-id="element-54" />
      <Footer data-id="element-55" />
    </div>;
}